module.exports = __webpack_public_path__ + "img/business7.7eb7266e.png";